import L from 'leaflet/dist/leaflet';
import 'leaflet-easyprint';
import 'leaflet-measure/dist/leaflet-measure.fr';
import 'leaflet-fullscreen/dist/Leaflet.fullscreen.min';
import moment from 'moment';

export default class DapAttenteFormController {
	/* @ngInject */
	constructor(
		$scope,
		$timeout,
		$state,
		$stateParams,
		DAPsCommunicationService,
		DAPsService,
		DocumentsService,
		RouterHistoryService,
		ChantiersService,
		notification,
		$location,
		$anchorScroll,
		$translate,
		$uibModal,
		ModalService
	) {
		// Angular services
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.DAPsCommunicationService = DAPsCommunicationService;
		this.DAPsService = DAPsService;
		this.DocumentsService = DocumentsService;
		this.chantierService = ChantiersService;
		this.historyService = RouterHistoryService;
		this.notification = notification;
		this.$location = $location;
		this.$anchorScroll = $anchorScroll;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.ModalService = ModalService;

		// State
		this.currDap = null;
		this.untouchedDap = {};
		this.loading = true;

		this.isOpenForm = true;
		this.isChantierCreated = false;
		this.isTransporteurCreated = false;
		this.isChantierCreated = false;
		this.isDemandeurCreated = false;
		this.oldChantier = {};

		// Data sources
		this.chantiers = [];
		this.transporteurs = [];
		this.producteurs = [];
		this.sitesAccueil = [];

		// UI flags
		this.haveCreation = false;
		this.userCanDoAction = false;

		// Map
		this.map = null;
		this.zoom = 5;
		this.latitude = 45.5;
		this.longitude = 3.5;

		// Temp
		this.tmp = { chantier: [] };
		this.lastModeratedSiteId = null;
	}

	/* =========================
	 * Lifecycle
	 * ========================= */

	//Cycle de gestion de la carte, obligé à cause des ng-if
	$doCheck() {
		if (this.map || this.loadingMap) return;

		const el = document.getElementById('map');
		if (!el) return;

		if (el._leaflet_id) return;

		if (this.map || this.loadingMap) return;
		this.loadingMap = true;
		this.initCarte(el);
	}

	async $onInit() {
		this.isOpen = true;
		this.loading = true;

		// On lance le chargement du DAP et des sites accueil en parallèle
		const loadDapPromise = this.loadDap();
		const getSitesAccueilPromise = this.getSitesAccueil();

		await loadDapPromise;
		this.applyRustineCoords();
		this.untouchedDap = angular.copy(this.currDap);

		// markAsSeenIfNeeded n'a pas besoin d'être bloquant pour la suite
		const markAsSeenPromise = this.markAsSeenIfNeeded();

		this.applyChantierCreationOverride();
		this.applyDemandeurCreationOverride();
		this.applyTransporteurCreationOverride();

		// Normalise dates
		const changedDates = this.normalizeDatesFromChantierWithFallback();
		if (changedDates) {
			// update() appelle déjà checkForCreation()
			await this.update();
		}

		this.historyService.data = this.currDap;

		// On attend la fin des chargements restants et on lance le refresh des listes filtrées
		await Promise.all([
			getSitesAccueilPromise,
			markAsSeenPromise,
			this.refresh(true) // true pour indiquer qu'on vient de l'init et éviter de re-fetch sitesAccueil
		]);

		this.loading = false;
	}

	/* =========================
	 * Load / Init helpers
	 * ========================= */

	async loadDap() {
		this.currDap = await this.DAPsService.GetDapAttenteById(this.$stateParams.id);

		this.currDap.dateDebut = this.toDateString(this.currDap.dateDebut);
		this.currDap.dateFin = this.toDateString(this.currDap.dateFin);

		if (this.currDap.chantier) {
			this.currDap.chantier.dateDebut = this.toDateString(this.currDap.chantier.dateDebut);
			this.currDap.chantier.dateFin = this.toDateString(this.currDap.chantier.dateFin);
		}
	}

	applyRustineCoords() {
		// rustine pour récupérer les coords du chantier
		if (this.currDap && this.currDap.chantier) {
			this.currDap.latitude = this.currDap.chantier.latitude;
			this.currDap.longitude = this.currDap.chantier.longitude;
		}
	}

	async markAsSeenIfNeeded() {
		if (this.currDap && this.currDap.statut === 1) {
			this.currDap.statut = 2;
			await this.DAPsService.UpdateDapAttenteAsSeen(this.currDap.id, this.currDap.transporteurIsDemandeur);
		}
	}

	applyChantierCreationOverride() {
		this.isChantierCreated = !!this.$stateParams.chantierId;
		if (!this.isChantierCreated) return;

		this.oldChantier = this.currDap.chantier;
		this.currDap.chantier.id = parseInt(this.$stateParams.chantierId, 10);
		this.save();
	}

	applyTransporteurCreationOverride() {
		this.isTransporteurCreated = !!this.$stateParams.transporteurId;
		let index = this.$stateParams.transporteurIndex;
		if (index === undefined || index === null) index = 0;
		if (!this.isTransporteurCreated) return;

		this.currDap.transporteur[index].id = parseInt(this.$stateParams.transporteurId, 10);
		this.save();
	}

	applyDemandeurCreationOverride() {
		// preparation for further integration
		// this.isDemandeurCreated = !!this.$stateParams.demandeurId;
		// if (!this.isDemandeurCreated) return;
		// this.currDap.demandeur.id = parseInt(this.$stateParams.demandeurId, 10);
		// this.save();
	}

	/* =========================
	 * Dates helpers
	 * ========================= */

	todayStart() {
		const d = new Date();
		d.setHours(0, 0, 0, 0);
		return d;
	}

	endOfYear(date) {
		const year = (date ? new Date(date) : new Date()).getFullYear();
		return new Date(year, 11, 31, 23, 59, 59, 999);
	}

	isInvalidDate(value) {
		if (!value) return true;

		const d = new Date(value);
		if (isNaN(d.getTime())) return true;

		const year = d.getFullYear();
		return year <= 2000;
	}

	normalizeDatesFromChantierWithFallback() {
		let changed = false;

		// si date invalides, tenter de récupérer depuis chantier
		if (this.isInvalidDate(this.currDap.dateDebut)) {
			this.currDap.dateDebut = this.currDap.chantier && this.currDap.chantier.dateDebutLivraison;
			changed = true;
		}
		if (this.isInvalidDate(this.currDap.dateFin)) {
			this.currDap.dateFin = this.currDap.chantier && this.currDap.chantier.dateFinLivraison;
			changed = true;
		}

		// et au cas où dateFin < dateDebut, on corrige aussi
		const deb = new Date(this.currDap.dateDebut);
		const fin = new Date(this.currDap.dateFin);
		if (!this.isInvalidDate(deb) && !this.isInvalidDate(fin) && fin < deb) {
			this.currDap.dateFin = this.endOfYear(deb);
			changed = true;
		}

		return changed;
	}

	/* =========================
	 * Data loading
	 * ========================= */

	async refresh(skipSitesAccueil = false) {
		// On lance les chargements en parallèle
		const promises = [this.getChantier(), this.getTransporteurs(), this.getProducteurs()];
		if (!skipSitesAccueil) {
			promises.push(this.getSitesAccueil());
		}

		await Promise.all(promises);

		await this.checkForCreation();
	}

	async getProducteurs() {
		try {
			this.producteurs = await this.DAPsService.getProducteursBySite(this.currDap.demandeurId);

			if (this.currDap.producteur && this.currDap.producteur.id === 0) {
				this.currDap.producteur.code = 'A CREER';

				if (this.$stateParams.producteurId) {
					this.currDap.producteur = this.producteurs.find((x) => x.id === this.$stateParams.producteurId);

					// update + reload comme avant
					await this.update();
					this.$stateParams.producteurId = null;
					this.$state.reload();
					return;
				} else {
					this.producteurs.push(this.currDap.producteur);
				}
			}
		} catch (error) {
			console.log(error);
		}
	}

	async getSitesAccueil() {
		if (this.sitesAccueil && this.sitesAccueil.length > 0) {
			return;
		}
		try {
			const sites = await this.DAPsService.getSiteCommerciaux();
			this.sitesAccueil = sites.map((site) => ({
				...site,
				nomSociete: site.libelle,
				libelle: undefined
			}));
		} catch (error) {
			console.log(error);
		}
	}

	async getTransporteurs() {
		try {
			const siteId = this.currDap.siteAccueil && this.currDap.siteAccueil[0] && this.currDap.siteAccueil[0].id;
			if (!siteId) return;

			this.transporteurs = await this.DAPsService.getTransporteursBySite(siteId);

			// Cas création transporteur depuis un autre écran
			if (this.$stateParams.transporteurId) {
				const t = this.transporteurs.find((x) => x.id === this.$stateParams.transporteurId);
				this.currDap.transporteur[this.$stateParams.transporteurIndex] = t;

				// update + reload comme avant
				await this.update();
				this.$stateParams.transporteurId = null;
				this.$state.reload();
				return;
			}

			// pousse les "A CREER" pour multi-select (inchangé)
			(this.currDap.transporteur || []).forEach((x) => {
				if (x.id === 0) {
					x.code = 'A CREER';
					this.transporteurs.push(x);
				}
			});
		} catch (error) {
			console.log(error);
		}
	}

	async getChantier() {
		try {
			this.chantiers = await this.DAPsService.getChantiersBySite(this.currDap.demandeurId);

			if (this.currDap.chantier && this.currDap.chantier.id === 0) {
				this.currDap.chantier.code = 'A CREER';
				this.chantiers.push(this.currDap.chantier);
				return;
			}

			// conserve documents lors du remap
			const documents = this.currDap.chantier && this.currDap.chantier.documents;
			const found = this.chantiers.find((x) => x.id === (this.currDap.chantier && this.currDap.chantier.id));
			if (found) {
				this.currDap.chantier = found;
				this.currDap.chantier.documents = documents;
			}
		} catch (error) {
			console.error(error);
		}
	}

	/* =========================
	 * Multi-select handlers (⚠︝ conservés)
	 * ========================= */

	async saveSelectedProducteur(producteur) {
		// mono-select (inchangé)
		if (!this.currDap.producteur || producteur.id !== this.currDap.producteur.id) {
			this.currDap.producteur = producteur;
		} else {
			this.currDap.producteur = null;
			this.producteurs.forEach((x) => {
				if (x.id === producteur.id) x.selected = false;
			});
		}

		await this.checkForCreation();
	}

	async saveSelectedTransporteurs(transporteur) {
		// multi-select (conservé, mais plus sûr)
		const list = this.currDap.transporteur || (this.currDap.transporteur = []);

		const alreadySelected = list.some((x) => x.id === transporteur.id && x.libelle === transporteur.libelle);

		if (alreadySelected) {
			this.currDap.transporteur = list.filter((x) => !(x.id === transporteur.id && x.libelle === transporteur.libelle));
		} else {
			list.push(transporteur);
		}

		await this.refresh();
		await this.checkForCreation();
	}

	async saveSelectedSiteAccueil(site) {
		// multi-select (conservé, mais plus sûr)
		const list = this.currDap.siteAccueil || (this.currDap.siteAccueil = []);

		const alreadySelected = list.some((x) => x.id === site.id && x.nomSociete === site.nomSociete);

		if (alreadySelected) {
			this.currDap.siteAccueil = list.filter((x) => !(x.id === site.id && x.nomSociete === site.nomSociete));
		} else {
			list.push(site);
		}
	}

	async saveSelectedChantier(chantier) {
		// mono-select (inchangé)
		if (!this.currDap.chantier || chantier.id !== this.currDap.chantier.id) {
			this.currDap.chantier = chantier;
		} else {
			this.currDap.chantier = null;
			this.chantiers.forEach((x) => {
				if (x.id === chantier.id) x.selected = false;
			});
		}

		await this.checkForCreation();
	}

	/* =========================
	 * Validation / creation flags
	 * ========================= */

	isProducteurToCreate() {
		return !this.currDap.producteur || this.currDap.producteur.id === 0;
	}

	isChantierToCreate() {
		return !this.currDap.chantier || this.currDap.chantier.id === 0;
	}

	haveTransporteursToCreate() {
		const list = this.currDap.transporteur || [];
		return list.length === 0 || list.some((x) => x.id <= 0);
	}

	async isFormInvalid() {
		if (this.isProducteurToCreate()) return true;
		if (this.isChantierToCreate()) return true;
		if (this.haveTransporteursToCreate()) return true;
		if (!this.currDap.dateDebut) return true;
		if (!this.currDap.dateFin) return true;
		return false;
	}

	async checkForCreation() {
		this.haveCreation = await this.isFormInvalid();
		await this.checkifUserCanDoActionOnDap();
	}

	async checkifUserCanDoActionOnDap() {
		const siteId = this.currDap.siteAccueil && this.currDap.siteAccueil[0] && this.currDap.siteAccueil[0].id;
		if (!siteId) {
			this.userCanDoAction = false;
			return;
		}

		if (this.lastModeratedSiteId === siteId) {
			return;
		}

		this.userCanDoAction = await this.DAPsService.checkModeration(siteId);
		this.lastModeratedSiteId = siteId;
	}

	/* =========================
	 * Domain helpers
	 * ========================= */

	getContamination(chantier) {
		if (chantier.isContamine) return 2;
		if (chantier.isPotentielContamine) return 1;
		return 0;
	}

	toDate(date) {
		return moment(date, 'DD/MM/YYYY HH:mm').toDate();
	}

	toDateString(date) {
		if (typeof date == 'string') return date;
		return moment(date).format('DD/MM/YYYY HH:mm');
	}

	/* =========================
	 * Persist
	 * ========================= */

	buildUpdatePayload() {
		const data = {
			id: this.currDap.id,
			transporteurIsDemandeur: this.currDap.transporteurIsDemandeur
		};

		if (this.currDap.chantier !== this.untouchedDap.chantier) data.chantier = this.currDap.chantier;

		if (this.currDap.transporteur !== this.untouchedDap.transporteur || this.$stateParams.transporteurId) {
			data.transporteur = this.currDap.transporteur;
		}

		if (this.currDap.producteur !== this.untouchedDap.producteur) data.producteur = this.currDap.producteur;

		if (this.currDap.dateFin !== this.untouchedDap.dateFin) data.dateFin = this.currDap.dateFin;

		if (this.currDap.dateDebut !== this.untouchedDap.dateDebut) data.dateDebut = this.currDap.dateDebut;

		data.dateDebut = this.toDate(this.currDap.dateDebut);
		data.dateFin = this.toDate(this.currDap.dateFin);

		if (this.currDap.chantier) {
			data.chantier.dateDebut = this.toDate(this.currDap.chantier.dateDebut);
			data.chantier.dateFin = this.toDate(this.currDap.chantier.dateFin);
		}

		return data;
	}

	async update() {
		let res = false;
		try {
			const data = this.buildUpdatePayload();
			this.DAPsService.UpdateDapAttente(data);
			res = true;
		} catch (error) {
			console.error(error);
		}
		await this.checkForCreation();
		return res;
	}

	async save() {
		this.loading = true;

		const res = await this.update();
		if (res) this.notification.success(this.$translate.instant('DAPS.ATTENTE.SAVE_SUCCESS'));
		else this.notification.error(this.$translate.instant('DAPS.ATTENTE.SAVE_ERROR'));

		this.loading = false;
	}

	/* =========================
	 * Modals / actions
	 * ========================= */

	openValidationModal(isRefus) {
		this.$uibModal.open({
			animation: true,
			size: 's',
			component: 'dapValidationModal',
			resolve: {
				dap: () => this.currDap,
				isRefus: () => isRefus
			},
			controllerAs: '$ctrl'
		});
	}

	async validate() {
		try {
			this.openValidationModal(false);
		} catch (error) {
			console.log(error);
		}
	}

	async reject() {
		try {
			this.openValidationModal(true);
		} catch (error) {
			this.notification.error(this.$translate.instant('DAPS.ATTENTE.REJ_ERROR'));
			console.log(error);
		}
	}

	async restore() {
		try {
			await this.DAPsService.UpdateDapAttenteAsSeen(this.$stateParams.id);
			this.notification.success(this.$translate.instant('DAPS.ATTENTE.RESTORE_TOAST'));
			this.currDap.statut = 2;
		} catch (error) {
			this.notification.success(error.error);
		}
	}

	annuler() {
		if (!this.historyService.back()) {
			this.$state.go('daps.list');
		}
	}

	/* =========================
	 * Download
	 * ========================= */

	async downloadDocument(id, filename) {
		const resultat = await this.DAPsService.getDapAttenteFileById(id);
		const data = resultat.data;

		let headers = resultat.headers;
		headers = headers();

		const contentType = headers['content-type'];

		try {
			const blob = new Blob([data], { type: `${contentType};charset=UTF-8` });
			const url = window.URL.createObjectURL(blob);

			const linkElement = document.createElement('a');
			linkElement.setAttribute('href', url);
			linkElement.setAttribute('download', filename);

			linkElement.dispatchEvent(
				new MouseEvent('click', {
					view: window,
					bubbles: true,
					cancelable: false
				})
			);
		} catch (ex) {
			console.log(ex);
		}
	}

	/* =========================
	 * Map
	 * ========================= */

	getMapDefaults() {
		const lat = this.currDap && this.currDap.latitude ? this.currDap.latitude : 45.5;
		const lng = this.currDap && this.currDap.longitude ? this.currDap.longitude : 3.5;
		const zoom = lat && lng ? 15 : 5;
		return { lat, lng, zoom };
	}

	initCarte(el) {
		if (this.map) return;

		const { lat, lng, zoom } = this.getMapDefaults();
		this.latitude = lat;
		this.longitude = lng;
		this.zoom = zoom;

		this.map = L.map(el).setView([this.latitude, this.longitude], this.zoom);
		this.map.scrollWheelZoom.disable();

		const Mapnik = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			attribution: '&copy; Les contributeurs <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
			maxZoom: 20
		});
		Mapnik.addTo(this.map);

		const blueMarker = L.icon({
			iconUrl: 'assets/img/pin_GO.png',
			iconSize: [64, 64],
			iconAnchor: [8, 55]
		});

		this.marqueurSite = L.marker([this.latitude, this.longitude], {
			icon: blueMarker,
			draggable: false
		});

		this.marqueurSite.addTo(this.map);
		this.loadingMap = false;
	}
}
